import React, { useEffect, useRef, useState } from "react";
import api from "../api";
import { Link } from "react-router-dom";
import { Sparkles, Star } from "lucide-react";

/**
 * Marquee-style scrolling banner of currently-boosted MNS — appears on
 * client-side pages to give boosted MNS extra visibility.
 * Pure CSS animation (no library). Pauses on hover.
 */
export default function BoostedBanner() {
  const [items, setItems] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    api.get("/boosted-mns").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (!items || items.length === 0) return null;

  // Duplicate items so the marquee loops seamlessly
  const loop = [...items, ...items];

  return (
    <div className="boosted-banner relative overflow-hidden bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 border-y border-amber-200/70" data-testid="boosted-banner">
      <div className="flex items-center gap-2 px-3 py-1.5 text-amber-900 text-xs font-semibold whitespace-nowrap">
        <Sparkles className="w-3.5 h-3.5" /> Coachs boostés cette semaine
        <span className="text-amber-600">→</span>
      </div>
      <div ref={trackRef} className="boosted-banner-track flex gap-4 px-3 pb-2">
        {loop.map((m, i) => {
          const name = m.profile?.first_name && m.profile?.last_name
            ? `${m.profile.first_name} ${m.profile.last_name}`
            : (m.user?.name || "Coach");
          const pic = m.user?.picture
            ? (m.user.picture.startsWith("http") ? m.user.picture : `${process.env.REACT_APP_BACKEND_URL}${m.user.picture}`)
            : `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0369A1&color=fff`;
          return (
            <Link
              key={`${m.user?.user_id}-${i}`}
              to={`/mns/${m.user?.user_id}`}
              className="shrink-0 inline-flex items-center gap-2 bg-white/80 hover:bg-white border border-amber-200 rounded-full pl-1 pr-3 py-1 text-xs text-slate-800 hover:text-amber-700 transition-colors shadow-sm"
              data-testid={`boost-card-${m.user?.user_id}`}
            >
              <img src={pic} alt="" className="w-7 h-7 rounded-full object-cover" />
              <span className="font-medium">{name}</span>
              {m.profile?.hourly_rate ? <span className="text-sky-700 font-semibold">{m.profile.hourly_rate}€/h</span> : null}
              {m.avg_rating ? <span className="flex items-center gap-0.5 text-amber-600"><Star className="w-3 h-3 fill-current" />{m.avg_rating.toFixed(1)}</span> : null}
            </Link>
          );
        })}
      </div>
      <style>{`
        .boosted-banner-track {
          animation: boosted-marquee 35s linear infinite;
          width: max-content;
        }
        .boosted-banner:hover .boosted-banner-track { animation-play-state: paused; }
        @keyframes boosted-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .boosted-banner-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
